module.exports = __webpack_public_path__ + "img/submit-btn-bg.b2f8790.png";